// File: src/components/potus/InfoBanner.jsx
import React from 'react';
import { Typography, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SECTOR_MAPPINGS } from '../../utils/constants';

const InfoBanner = ({ selectedSector, marketData }) => {
  const theme = useTheme();
  
  // Convert sector name to symbol (e.g., "Healthcare" -> "XLV")
  const sectorSymbol = SECTOR_MAPPINGS[selectedSector];
  const sectorData = marketData[sectorSymbol];
  const inaugurationChange = sectorData?.['Inauguration'] || 0;
  const isPositive = inaugurationChange >= 0;

  return (
    <Paper
      variant="stats"
      sx={{
        p: 2,
        mb: 3,
        backgroundColor: theme.palette.mode === 'dark'
          ? 'rgba(19, 47, 76, 0.4)'
          : 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(10px)',
        border: theme.palette.mode === 'dark'
          ? '1px solid rgba(255, 255, 255, 0.1)'
          : '1px solid rgba(0, 0, 0, 0.1)',
      }}
    >
      <Typography variant="body1" component="div">
        Since the inauguration of Donald J. Trump on January 20, 2025, the{' '}
        <strong>{selectedSector}</strong> has{' '}
        <span
          style={{
            color: isPositive 
              ? theme.palette.positive.main 
              : theme.palette.negative.main,
            fontWeight: 'bold'
          }}
        >
          {isPositive ? 'grown' : 'declined'} by {isPositive ? '+' : ''}{inaugurationChange.toFixed(2)}%
        </span>
        .
      </Typography>
    </Paper>
  );
};

export default InfoBanner;